import Text from "ab-text";
import MenuDesplegable from "ab-carta";
import ParagraphText from "ab-paragraph-text";

import "./ficha-carta.scss";

const FichaCarta = ({
  title = "Un menú a tu medida",
  text = [],
  content,
  items = [],
  h1,
  animated,
  carta,
  tipo,
  menu,
}) => {
  // console.log("FichaCarta -", carta, tipo, menu);
  return (
    <div
      className={`ficha-carta${
        text.length > 0 || content?.length > 0 || tipo == "Santuario"
          ? " padding"
          : ""
      }`}
    >
      {h1 ? <Text element="h1">{h1}</Text> : null}
      <div className="row">
        <div>
          <Text element="h2" animated={animated}>
            {title}
          </Text>
          <ParagraphText text={text} content={content} singleColumn />
        </div>

        <MenuDesplegable items={items} carta={carta} menu={menu} />
      </div>
    </div>
  );
};

export default FichaCarta;
